import SearchModel from'./SearchModel';
class DocumentModel {
    id              = -1
    typeDocument           = ""
    numberDocument          = ""
    seriaDocument          = ""
    descDocument            =""
    searchModel = null;
}

export default DocumentModel